import styled from 'styled-components'
import { breakpoints } from '../../../../constants/breakpoints.constants'

export const StyledCadastreSe = styled.section`
	padding-bottom: 5rem;
	position: relative;
	overflow-x: hidden;
	display: flex;
	align-items: center;
	width: 100%;

	@media (min-width: ${breakpoints.MOBILE}px) {
		min-height: 625px;
	}

	.container {
		flex: 1;
		@media (min-width: ${breakpoints.MOBILE}px) {
			flex: auto;
		}
	}

	.info {
		max-width: 480px;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;

		@media screen and (max-width: ${breakpoints.MOBILE}px) and (orientation: landscape) {
			margin: 0 auto;
		}
	}

	.bus {
		display: none;

		@media (min-width: ${breakpoints.MOBILE}px) {
			display: block;
			position: absolute;
			top: 0;
			right: 0;
			transform: translateX(160px);
			transition: transform 1s ease-out;
		}

		&.show {
			transform: translateX(0);
		}
	}
`
